module.exports = __webpack_public_path__ + "static/media/23.3d175405.mp3";